module.exports = "/_next/static/images/game-1-phone-gallery-08-23-1134-fd21d7d8fa20446955876ad36b9ca87c.jpg";